import { SubmissionError } from 'redux-form';

import * as sessionApi from '../services/api/session';

export const SET_SESSION_USER = 'SET_SESSION_USER';
export const REQUIRES_CONFIRMATION_CHANGED = 'REQUIRES_CONFIRMATION_CHANGED';

export function changeRequiresConfirmation(requiresConfirmation) {
    return {
        type: REQUIRES_CONFIRMATION_CHANGED,
        requiresConfirmation
    }
}

export function setSessionUser(user) {
    return {
        type: SET_SESSION_USER,
        user
    }
}

export function login(params) {
    return dispatch => {
        return sessionApi
            .login(params)
            .then((user) => {
                dispatch(setSessionUser(user));

                if (user.confirmed) {
                    dispatch(changeRequiresConfirmation(false));
                }
            })
            .catch((res) => {
                if(res.message === 'two_factor_auth_required'){
                    window.location = res.url;
                } else {
                    throw new SubmissionError({
                        _error: res
                    });
                }
            });
    }
}

export function logout(successCallback) {
    return dispatch => {
        return sessionApi
            .logout()
            .then(() => {
                dispatch(setSessionUser(null));
                successCallback();
            });
    }
}